import { useAppSelector } from '@store/hooks';
import { selectUsers } from '@store/slices/users/usersSlice';
import { PERMISSION_TITLES } from '@hooks/useDefinePermissions';
import { WEB_USER } from '@routes/helpers';

const CHAT_PERMISSION_NAMES: string[] = [
  PERMISSION_TITLES.MONITORING,
  PERMISSION_TITLES.RIDE,
];

/**
 * Single access rule for every driver-chat surface, so the entry button never
 * shows when the launcher that renders the chat is disabled.
 *
 * The launcher lives on every screen, so this reads the user's full permission
 * list. `usePermissions` is scoped to the current section (it only knows the
 * Ride/Monitoring modules while you are inside them) and would hide the chat
 * everywhere else, Home included.
 */
export const useDriverChatAccess = () => {
  const { userInfo, userType } = useAppSelector(selectUsers);

  const isDispatcher = !!userInfo && userType === WEB_USER;
  const hasPermission = (userInfo?.permissions ?? []).some(
    (permission) =>
      CHAT_PERMISSION_NAMES.includes(permission.name) &&
      permission.abilities?.some((ability) => ability.name === 'Read')
  );

  return isDispatcher && hasPermission;
};
